export const ADD_NEW_STOCK__DETAILS = "ADD_NEW_STOCK__DETAILS";
export const FETCH_ALL_PRODUCT_STOCK_ENTRY_LIST =
  "FETCH_ALL_PRODUCT_STOCK_ENTRY_LIST";
export const EDIT_OLD_SINGLE_PRODUCT_STOCK_DETAILS =
  "EDIT_OLD_SINGLE_PRODUCT_STOCK_DETAILS";
export const UPDATE_PRODUCT_STOCK_DETAILS = "UPDATE_PRODUCT_STOCK_DETAILS";
export const DELETE_PRODUCT_STOCK_ENTRY_DETAILS =
  "DELETE_PRODUCT_STOCK_ENTRY_DETAILS";
export const FIND_PRODUCT_BY_NAME_DESIGN = "FIND_PRODUCT_BY_NAME_DESIGN;";
